<template>
  <ul>
    <li v-for="(menu, index) in menus" :key="menu.id">
      <template v-if="menu.menu_category_id == 2">
        <div
          @click="pushRoleCategoryList(menu.role_slug)"
          class="flex items-center justify-between cursor-pointer hover:bg-gray-200 w-full px-4 py-2"
        >
          <div class="flex items-center">
            <base-svg-icon class="w-5 mr-2" :path="menu.icon" />
            <div class="flex items-center text-gray-700">
              <div class="w-40 sm:w-48 truncate font-light">{{ menu.title }}</div>
              <template v-if="validateUrl(menu.url) === LINK_STATUS.external">
                <base-svg-icon class="w-4" :path="mdiOpenInNew" />
              </template>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div
          @click="validateUrl(menu.url) ? externalOrInternalLink(menu.url, menu.open) : handleToggle(index)"
          class="flex items-center justify-between cursor-pointer hover:bg-gray-200 w-full px-4 py-2"
          :class="[menu.url === currentUrl ? 'bg-blue-200': '']"
        >
          <div class="flex items-center">
            <base-svg-icon class="w-5 mr-2" :path="menu.icon" />
            <div class="flex items-center text-gray-700">
              <div class="w-40 sm:w-48 truncate font-light">{{ menu.title }}</div>
              <template v-if="validateUrl(menu.url) === LINK_STATUS.external">
                <base-svg-icon class="w-4" :path="mdiOpenInNew" />
              </template>
            </div>
          </div>
          <template v-if="!validateUrl(menu.url) && Array.isArray(menu.menu_subs) && menu.menu_subs.length">
            <base-svg-icon
              class="w-6 transform transition-transform duration-500 cursor-pointer"
              :class="isOpenSubmenu[index] ? 'rotate-90' : 'rotate-0'"
              :path="mdiChevronRight"
            />
          </template>
        </div>
      </template>
      <template v-if="!validateUrl(menu.url) && Array.isArray(menu.menu_subs) && menu.menu_subs.length">
        <layouts-auth-sidebar-content-submenu :menuSubs="menu.menu_subs" :isOpen="isOpenSubmenu[index]" />
      </template>
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent, ref, PropType, computed } from 'vue'

import { mdiOpenInNew, mdiChevronRight } from '@mdi/js'
import { MenuAttributes } from '@/types/models/menu'
import { validateUrl, externalOrInternalLink, LINK_STATUS } from '@/router/utils'
import { useRoute } from 'vue-router'
import { useRouter } from 'vue-router'
import { useStore } from '@/store/index'

import BaseSvgIcon from '@/components/BaseSvgIcon.vue'
import LayoutsAuthSidebarContentSubmenu from '@/components/LayoutsAuthSidebarContentSubmenu.vue'

export default defineComponent({
  props: {
    menus: {
      type: Array as PropType<MenuAttributes[]>,
      'default': () => ([]),
    }
  },
  components: { BaseSvgIcon, LayoutsAuthSidebarContentSubmenu },
  setup(props) {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const isOpenSubmenu = ref(Array(props.menus.length).fill(true))

    const handleToggle = (index: number) => {
      isOpenSubmenu.value.splice(index, 1, !isOpenSubmenu.value[index])
    }

    const currentUrl = computed(() => {
      return `${route.path}${window.location.search}`
    })

    const pushRoleCategoryList = (role_slug: string) => {
      store.dispatch('menu/switchSidebarOpen')
      router.push({ name: 'RoleCategoryList', params: { slug: role_slug } })
    }

    return {
      isOpenSubmenu,
      handleToggle,
      validateUrl,
      externalOrInternalLink,
      pushRoleCategoryList,
      mdiOpenInNew,
      mdiChevronRight,
      LINK_STATUS,
      currentUrl
    }
  },
})
</script>
